import { FC } from "react";

type ServiceFill50IconProps = {
  color: string;
  outline?: boolean;
};

const WRENCH_PATH =
  "M21.5995 27.8831L22.5 28.3333V36.4264C22.5 36.5699 22.5918 36.6973 22.7279 36.7426L23.1553 36.8851C24.3527 37.2842 25.6473 37.2842 26.8447 36.8851L27.2721 36.7426C27.4082 36.6973 27.5 36.5699 27.5 36.4264V28.3333L28.4005 27.8831C30.913 26.6268 32.5 24.059 32.5 21.25V21.0323C32.5 18.3567 30.9884 15.9108 28.5953 14.7143C28.0921 14.4627 27.5 14.8286 27.5 15.3912V21.4264C27.5 21.5699 27.4082 21.6973 27.2721 21.7426L25.1054 22.4649C25.037 22.4877 24.963 22.4877 24.8946 22.4649L22.7279 21.7426C22.5918 21.6973 22.5 21.5699 22.5 21.4264V15.3912C22.5 14.8286 21.9079 14.4627 21.4047 14.7143C19.0116 15.9108 17.5 18.3567 17.5 21.0323V21.25C17.5 24.059 19.087 26.6268 21.5995 27.8831Z";

export const Service50Icon: FC<ServiceFill50IconProps> = ({
  color,
  outline,
}) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <clipPath id="wrench">
      <path d={WRENCH_PATH} />
    </clipPath>

    <mask id="inverse-wrench">
      <rect id="bg" x="0" y="0" width="100%" height="100%" fill="white" />
      <path d={WRENCH_PATH} fill="black" />
    </mask>

    <path
      d="M20.8755 5.44656C23.1536 3.16852 26.8465 3.16854 29.1245 5.44656L44.5542 20.8753C46.8319 23.1532 46.8318 26.8463 44.5542 29.1243L29.1245 44.554C26.8465 46.8317 23.1535 46.8317 20.8755 44.554L5.44681 29.1243C3.16879 26.8462 3.16876 23.1533 5.44681 20.8753L20.8755 5.44656Z"
      fill={color}
      {...{
        clipPath: outline ? "url(#wrench)" : undefined,
        mask: outline ? undefined : "url(#inverse-wrench)",
      }}
    />
  </svg>
);
